<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <form-custom-fields-generator v-model="form.customer_custom_fields" public>
            <template #bottom>
                <div class="text-end">
                    <v-btn @click="submit()" color="success" class="mt-5" :loading="loading">ثبت اطلاعات</v-btn>
                </div>
            </template>
        </form-custom-fields-generator>
    </div>
</template>

<script>
export default {
    title: "فیلد های سفارشی مشتریان",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.customer_custom_field;
    },
    data() {
        return {
            loading: false,
            form: {
                customer_custom_fields: [],
            }
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.$customerCustomFieldUpdate(this.form).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$system.setSystemDefaults(true);
                    this.$toast.success(res.message);
                }
            }).finally(()=>{this.loading = false});
        }
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.$customerCustomFieldList().then(res => {
                if (res && res.status == 'OK')
                    this.form.customer_custom_fields = res.data;
            });
            this.$loading.finish();
        });
    }
};
</script>
